<script lang="ts" setup>
import Icon from "../ui/Icon.vue";
import { mdiLoading, mdiWindowMinimize } from "@mdi/js";
import { useSettings } from "~/store/settings";

const router = useRouter();
const settings = useSettings();

const livechatActive = computed(() => {
	if (document.getElementById("cx-nudge") || document.getElementById("cx-chat")) return true;
});

const closeLoader = () => {
	window.__CONNEXONE_LIVECHAT__.closeWidget();
	settings.liveChatCanceled = true;
}
</script>
<template>
	<div
		v-if="!livechatActive || settings.liveChatCanceled"
		class="hidden max-[540px]:flex h-screen w-screen fixed top-0 bg-light-50 z-[100] justify-center items-center flex-col"
	>
		<div class="bg-dark-900 px-[11px] pt-1 h-16 w-screen fixed top-0 flex justify-between items-center shadow">
			<div class="flex gap-2">
				<div class="w-10 h-10 p-1 rounded-full bg-dark-400 animate-pulse -translate-y-1" />
			</div>
			<div class="flex flex-col mr-auto ml-[11px]">
				<div class="h-[18px] w-24 bg-dark-500 animate-pulse rounded mb-1" />
				<div class="h-[14px] w-44 bg-dark-500 animate-pulse rounded mb-1" />
			</div>
			<Icon :path="mdiWindowMinimize" :class="'w-10 h-10 fill-light-50 scale-x-75 scale-y-50 mt-auto'" @click="closeLoader()" />
		</div>
		<Icon :path="mdiLoading" class="animate-spin fill-identity w-16 h-16" />
	</div>
</template>
